import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { FlyerPriority, UIFlyerService } from '../../../app/package/base/service/flyer/flyer-service';
import styles from './ui-flyer-bar.css?inline';
import '../ui-btn/ui-btn';

const CName = 'ui-flyer-bar';

@customElement(CName)
export class UIFlyerBar extends LitElement implements UIFlyerService {
  static readonly styles = unsafeCSS(styles);

  @property() priority: FlyerPriority = 'compliance';
  @property() title = '';
  @property() subtitle = '';
  @property() ctaLabel = '';
  @property({ attribute: false }) onCtaClick?: () => void;

  close() {
    window.$app.flyer.closeAll(this.priority);
  }

  render() {
    return html`
      <div class="flyer-bar">
        <slot>
          ${
            this.title
              ? html`
                <div class="flyer-bar__text">
                  <div class="flyer-bar__title">${this.title}</div>
                  ${this.subtitle ? html`<div class="flyer-bar__subtitle">${this.subtitle}</div>` : nothing}
                </div>
                ${
                  this.ctaLabel
                    ? html`<ui-btn variant="light" @click=${this.onCtaClick}>${this.ctaLabel}</ui-btn>`
                    : nothing
                }
              `
              : nothing
          }
        </slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIFlyerBar;
  }
}
